/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from '@/application';
import { getAgent } from './agent';

import loadingConfig from './config/loading.config.json';
import { IGetHolderGroupProps } from './components';
import { IAddGroupMethodsProps } from './components';
import { camelCase, capitalCase } from 'change-case';
import { v4 as uuidv4 } from 'uuid';

const is = require('is_js');

const SERVICE_NAME = 'SuppChainTempOverViewPageService';

export class SuppChainTempOverViewPageService {
  private static instance: SuppChainTempOverViewPageService;
  private vapp: VApplication;
  private criteria: any;
  private kanbanList: any;
  private kanbanFormattedFormData: any;

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
  }

  public static getInstance(props: any = {}): SuppChainTempOverViewPageService {
    if (!SuppChainTempOverViewPageService.instance) {
      SuppChainTempOverViewPageService.instance =
        new SuppChainTempOverViewPageService(props);
    }
    return SuppChainTempOverViewPageService.instance;
  }

  public presetKanbanList(data: any) {
    console.log(`data presetKanbanList`, data);
    let _result: any[] = [];
    if (data && Array.isArray(data) && data.length > 0) {
      data.map((field: any, index: number) => {
        _result.push({
          title: field?.compProps?.label,
          attributeType: field?.type,
          isRequired: field?.compProps?.required,
          id: uuidv4(),
        });
      });
    }
    console.log(`_result presetKanbanList`, _result);
    this.kanbanList = [{ title: 'Attributes', id: '1', cards: _result }];
    this.kanbanFormattedFormData = this._formatKanbanFormData(_result);
  }

  public setKanbanList(data: any) {
    this.kanbanList = data;
    const cards =
      data && Array.isArray(data) && data.length > 0 && data[0]?.cards;
    if (cards && Array.isArray(cards) && cards.length > 0) {
      this.kanbanFormattedFormData = this._formatKanbanFormData(cards);
    }
  }
  public _formatKanbanFormData(cards: any) {
    let _result: any[] = [];
    if (cards && Array.isArray(cards) && cards.length > 0) {
      cards.map((card: any, index: number) => {
        _result.push({
          type: card?.attributeType,
          compProps: {
            id: card?.title && camelCase(card?.title),
            label: card?.title && capitalCase(card?.title),
            required: card?.isRequired,
            placeholder: `Enter ${card?.title}`,
          },
        });
      });
    }

    return _result;
  }

  public getKanbanFormattedFormData() {
    return this.kanbanFormattedFormData;
  }

  public getKanbanList() {
    let kanbanList = this.kanbanList;
    console.log(`kanbanList in getKanbanList`, kanbanList);
    if (kanbanList && kanbanList.length > 0) {
      return this.kanbanList;
    } else {
      return null;
    }
  }

  private setCriteria(data: any) {
    this.criteria = [...this.criteria, ...data];
  }

  public resetCriteria() {
    this.criteria = [];
  }

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }

  public async getPageContent(args: IGetHolderGroupProps) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    if (args?.where) {
      this.setCriteria(args?.where);
    }

    //Header Props
    compProps = await agent.getHeaderProps({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    //Settings Props
    compProps = await agent.getSettingsProps({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    //UserLists Props
    compProps = await agent.getAppCardListProps({
      ...args,
      where: [...this.criteria, ...args?.where],
    });
    if (compProps) {
      console.log(`inside service`, compProps);
      content = { ...content, ...compProps };
    }
    return content;
  }
  public getGraphData() {
    const agent = getAgent();
    return agent?.getFormatOverviewDetailSync();
  }

  public getAgent() {
    return getAgent();
  }

  public async updateTraceStep(args: any) {
    const agent = getAgent();
    return await agent.updateTraceStep(args);
  }
}
